<template>
  <b-card-body class="text-center">
    <div class="table-responsive  above1200">
        <!-- <div v-for="(month, index) in months" :key="index" >
          <div :class="{'adtDevider' : develop == 'adt'}" class="monthRow" v-for="(value) in tournDates" :key="value" v-show="value.includes(month.value)">
            <div class="container monthindex">{{month.full_name}} {{id}}</div>
          </div> -->
          <b-table :items="filteredList" :fields="fields" :tbody-tr-class="rowClass"> 
            <template #cell(reports)="row">
              <template >
                <b-link :to="'/tournament/' + row.item.code + '/' + id  + '?tour=' + tournID" class="noDec">
                  <button class="reportBTN" :style="colourTour">
                    More Details
                  </button>
                </b-link>
              </template>
            </template>
            <template #cell(full_name)="row">
              <b-nav-item
                class="tourLink"
                :to="'/tournament/' + row.item.code + '/' + id  + '?tour=' + tournID"
                :class="{major : row.item.major == 'Y' }"
                :filter="filter"
              >
                <span class="courseNameText">
                {{ row.item.full_name }} <span v-if="row.item.cancelled == 'Y'" class="cancelled">Cancelled</span>
                </span>
              </b-nav-item>
            </template>
            <template #cell(dates)="row" >
              <span :class="{major : row.item.major == 'Y'}">
                <div class="datesSec">
                  <span class="monthText">{{ row.item.dates }}</span>
                </div>
              </span>
            </template>
            <template #cell(total_prize_fund)="row">
              <span class="fundSection" :class="{major : row.item.major == 'Y'}">
                {{ row.item.total_prize_fund }}
              </span>
            </template>
          </b-table>
        <!-- </div> -->
    </div>
    <div class="table-responsive  below1200">
        <!-- <div v-for="(month, index) in months" :key="index" >
          <div :class="{'adtDevider' : develop == 'adt'}" class="monthRow" v-for="(value) in tournDates" :key="value" v-show="value.includes(month.value)">
            <div class="container monthindex">{{month.full_name}} {{id}}</div>
          </div> -->
          <b-table :items="filteredList" :fields="fields" :tbody-tr-class="rowClass"> 
            <template #cell(full_name)="row">
              <b-nav-item
                class="tourLink"
                :to="'/tournament/' + row.item.code + '/' + id  + '?tour=' + tournID"
                :class="{major : row.item.major == 'Y' }"
                :filter="filter"
              >
                <span class="courseNameText">
                   {{ row.item.short_name }} <span v-if="row.item.cancelled == 'Y'" class="cancelled">Cancelled</span>
                </span>
              </b-nav-item>
            </template>
            <template #cell(dates)="row" >
              <span :class="{major : row.item.major == 'Y'}">
                <div class="datesSec">
                  <span class="monthText">{{ row.item.dic_dates }}</span>
                </div>
              </span>
            </template>
          </b-table>
        <!-- </div> -->
    </div>
    <!-- <div v-if="tournDates != null" class="noTournsAvailable">No Tournaments Available</div> -->
  </b-card-body>
</template>

<script>
export default {
  name: "Schedule Table",
  props: ["id", "fields", "data", "code", "search", "months", "tournDates" , "newReports"],
  filters: {
    base: function(value) {
      return btoa(value);
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (this.code === item.code) return "live";
    },
    // reportReturn: function() {
    //   let arr = [];
    //   console.log("arr")
    //   console.log(arr)
    //   this.data.forEach((value) => {
    //     if (value.reports !== '') {
    //       value.reports.reports_entry.forEach((value2) => {
    //         if (value2.report_title.includes('Scores') || value2.report_title.includes('Scoreboard')) {
    //           arr.push(value2); 
    //         }
    //       })
    //     } else {
    //       console.log('No reports')
    //     }
    //   });
    // }
  },
  computed: {
    filteredList() {
      return this.data.filter(item => {
        const query = this.search.toLowerCase(); 
        return item.full_name.toLowerCase().includes(query);
      })
    },
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0'
      } else if (this.tournID == 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tournID == 'pam') {
        // backgroundColourTour = 'background-color: #fff; border: 1px solid #000'
        backgroundColourTour = "background-color: #c3bcce;color: #081C3F"
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'background-color: #c96b6b;color: #ffff'
      }
      return backgroundColourTour
    }
  },
  mounted() {
  // this.reportReturn();
  this.tournID = this.$route.query.tour;
  }
};
</script>

<style scoped>
.cancelled {
  background-color: #C8112E;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  position: relative;
  top: -2px;
}
span.monthText {
  color: #707070;
  font-size: 16px;
}
span.redtext {
  color: #081C3F;
  font-weight: 600;
}
.datesSec {
  /* display: grid;
  padding-top: 10px; */
}
.noDec:hover {
  text-decoration: none;
}
span.courseNameText {
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
::v-deep thead {
  /* display: none; */
}
.noTournsAvailable{
  text-align: center;
  display: block;
  font-size: 36px;
  color: #081C3F;
  margin: auto;
}
::v-deep thead > tr>  th {
  border-top: 0px solid #dee2e6;
}
tr.live > td > ul > a > button {
  background-color: #fff;
}
ul.nav.nav-pills.card-header-pills {
  display: block;
}
button.reportBTN {
  border: none;
  display: block;
  margin: auto;
  background-color: #00FFFE;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  width: 206px;
  height: 52px;
  color: #081C3F;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
button.reportBTN:hover {
  border: none;
  display: block;
  margin: auto;
  background-color: #081C3F!important;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  width: 206px;
  height: 52px;
  color: #fff!important;
  transform: translateY(-10px);
  background: #081C3F!important;
  border-radius: 26px;
}
::v-deep .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529 !important;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  color: #ffff;
}
::v-deep div#dropdown-dropleft > button {
  width: 150px;
  height: 35px;
  vertical-align: middle;
  padding-top: 7px;
}
::v-deep li.nav-item.tourLink > a{
  color: #000!important;
  font-weight: 600;
}
::v-deep li.nav-item.tourLink > a:hover{
  color: #081C3F!important;
  font-weight: 600;
}
::v-deep th:first-child {
  text-align: center;
  border-top-left-radius: 0px;
}
::v-deep th:last-child {
  text-align: center;
  border-top-right-radius: 0px;
}
::v-deep .dropdown-toggle::after {
  transform: rotate(-90deg);
}
::v-deep .dropleft .dropdown-toggle::after {
  vertical-align: 0;
}
::v-deep .dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
::v-deep .dropleft .dropdown-toggle::before {
  display: none;
}
.major {
  color: #081C3F!important;
  font-weight: bold!important;
}
.major > a {
  color: #081C3F!important;
  font-weight: bold!important;
}
::v-deep .live > td {
  color: #000;
}
::v-deep .live > td > span {
  color: #000!important;
}
li {
  list-style: none;
}
.card-body {
  padding-left: 0;
  padding-right: 0;
}
::v-deep table {
  text-align: left;
}
::v-deep th:first-child {
  text-align: left;
}
::v-deep td:first-child {
  text-align: left;
  padding-top: 40px;
  padding-bottom: 40px;
}
::v-deep th {
  background-color: #081C3F;
  font-size: 16px;
  font-weight: 500;
  position: sticky;
  top: 0;
  z-index: 111;
  font-weight: normal;
  text-align: left;
  height: 60px;
  vertical-align: middle !important;
}
::v-deep td {
  font-size: 16px !important;
  /* line-height: 18px; */
  color: #707070;
  vertical-align: middle!important;
  padding: 1px 1rem;
  text-align: left;
}
.tourLink > a {
  font-weight: bold;
  padding: 0.5rem 0;
}
.tourLink > a:hover {
  color: #081C3F!important;
}
::v-deep .live {
  color: white;
  background-color: #F8F8F8 !important;
}
::v-deep .live > td > li > a {
  color: #000 !important;
}

::v-deep .live > td > ul > div > button {
  color: #081C3F;
  background-color: white;
}
::v-deep .btn-secondary {
  color: #000;
  background-color: #ffffff;
  text-align: left;
  font-weight: normal;
}
.dropdown {
  /* border: 1px solid black; */
}
::v-deep .dropdown > button {
  font-size: 13px;
  padding-top: 2px;
  /* height: 20px; */
}
::v-deep .dropdown-toggle::before {
  transform: rotate(-90deg);
}

@media only screen and (min-width: 1199px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .above1200 {
    display: none;
  }
  ::v-deep th.noCourse {
    display: none
  }
  ::v-deep td.noCourse {
    display: none
  }
}
@media only screen and (max-width: 1222px) {
  ::v-deep button::after {
    float: right;
    margin-top: -12px!important;
    position: relative;
    right: -7px;
  }
  ::v-deep td.ReportClass {
    display: none!important;
  }
}
@media only screen and (max-width: 990px) {
  ::v-deep th.ReportClass > div{
    display: none;
  }
  td.ReportClass > ul{
    display: none!important;
  }
  span.monthText {
    position: relative;
    top: 0px;
  }
  .datesSec {
    display: grid;
    padding-top: 0px;
  }
}
@media only screen and (max-width: 768px) {
  span.redtext {
    color: #081C3F;
    font-weight: 600;
    line-height: normal;
  }
  ::v-deep span.courseNameText{
    display: block;
    color: #081C3F;
    font-size: 15px;
    font-weight: bold;
  }
  ::v-deep td {
    font-size: 18px !important;
    /* line-height: 18px; */
    color: #081C3F;
    vertical-align: middle;
    padding: 1px 1rem;
    text-align: left;
  }
  ::v-deep .dropdown-toggle {
    font-size: 14px;
  }
  ::v-deep .dropdown {
    /* width: 92%; */
    width: 100%;
  }
  ::v-deep tr > th:nth-child(4) {
    display: none;
  }
  ::v-deep tr > td:nth-child(4) {
    display: none;
  }
}
@media only screen and (max-width: 425px) {
  ::v-deep tr > td:nth-child(3) {
    display: none;
  }
  ::v-deep tr > th:nth-child(3) {
    display: none;
  }
}
</style>
